// @ts-nocheck
/**
 * Appointment Membership Step (Step 3)
 * Handles OneLife membership selection and pricing
 */

// Reset membership pricing display to default state
function resetMembershipPricingDisplay() {
    const regularPricingDiv = document.querySelector('.membership-pricing');
    const higherPricingDiv = document.querySelector('.membership-pricing-if-higher');
    const membershipCardSubtitle = document.querySelector('.membership-card-subtitle');

    // Reset all elements to default state
    if (regularPricingDiv) {
        regularPricingDiv.style.display = 'flex';
    }
    if (higherPricingDiv) {
        higherPricingDiv.style.display = 'none';
    }
    if (membershipCardSubtitle) {
        membershipCardSubtitle.style.display = 'block';
    }
}

// Show membership selection step (Step 3)
function showMembershipStep() {
    // Hide package selection
    const packageSelection = document.getElementById('select-package');
    if (packageSelection) {
        packageSelection.style.display = 'none';
    }

    // Show membership selection
    const membershipSelection = document.getElementById('membership-selection');
    if (membershipSelection) {
        membershipSelection.style.display = 'block';

        // Display combined appointment and package summary
        displayAppointmentAndPackageSummary();

        // Reset pricing display state first to ensure clean state
        resetMembershipPricingDisplay();

        // Ensure pricing is updated (call again with delay to ensure DOM is ready)
        setTimeout(() => {
            updateMembershipPricing();
        }, 100);
    }

    // Update progress steps
    if (typeof updateProgressSteps === 'function') {
        updateProgressSteps(3); // Step 3: OneLife Membership
    }

    // Scroll to top (smooth if supported, fallback otherwise)
    try {
        if ('scrollBehavior' in document.documentElement.style) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
            window.scrollTo(0, 0);
        }
    } catch (e) {
        // Fallback for very old browsers
        window.scrollTo(0, 0);
    }
}

// Display combined appointment and package summary
function displayAppointmentAndPackageSummary() {
    const summaryContainer = document.getElementById('selected-appointment-and-package-summary');
    const summaryContent = document.querySelector(
        '#selected-appointment-and-package-summary .appointment-summary-content',
    );

    if (!summaryContainer || !summaryContent) {
        console.warn('Appointment and package summary elements not found');
        return;
    }

    // Get appointment data
    let appointmentInfo = '';
    if (typeof selectedAppointmentData !== 'undefined' && selectedAppointmentData) {
        const { date, time, location } = selectedAppointmentData;
        appointmentInfo = `Screening: ${date} at ${time} at ${location}`;
    }

    // Get package data from session storage
    let packageInfo = '';
    const packageData = loadFromSession('selectedPackage', 'packageTimestamp', true);
    if (packageData && packageData.type) {
        const packageType = packageData.type;
        const packageName = packageType.charAt(0).toUpperCase() + packageType.slice(1);
        packageInfo = ` | ${packageName} Package`;
    }

    // Combine appointment and package info
    const combinedSummary = appointmentInfo + packageInfo;

    // Update the content and show the container
    summaryContent.textContent = combinedSummary;
    summaryContainer.style.display = 'block';

    // Update pricing display based on selected package
    updateMembershipPricing();
}

// Get packages product data (imported from appointment-package-selection.js)
function getPackagesProductData() {
    if (typeof window.AppointmentPackages?.getPackagesProductData === 'function') {
        return window.AppointmentPackages.getPackagesProductData();
    }
    return null;
}

// Get package price by membership type (enhanced version of getPackagePrice)
function getPackagePriceByMembership(packageType, membershipType) {
    const productData = getPackagesProductData();

    if (!productData || !productData.variants) {
        console.warn('No product data available for pricing');
        return 0;
    }

    // Map package types to enhancement option values
    const enhancementMap = {
        signature: 'None',
        silver: 'Silver',
        gold: 'Gold',
        platinum: 'Platinum',
    };

    const enhancement = enhancementMap[packageType.toLowerCase()];
    if (!enhancement) {
        console.warn('Unknown package type:', packageType);
        return 0;
    }

    // Find the variant with the matching membership and enhancement
    const variant = productData.variants.find(
        (v) => v.option1 === membershipType && v.option2 === enhancement,
    );

    if (variant) {
        // Parse price and convert from cents to dollars
        let priceStr = String(variant.price);
        let priceInCents = parseFloat(priceStr);
        let price = priceInCents / 100; // Convert cents to dollars

        return price;
    }

    console.warn(`No variant found for ${membershipType} ${enhancement}`);
    return 0;
}

// Update membership title based on pricing comparison
function updateMembershipTitle(nonMemberPrice, memberPrice) {
    const membershipTitle = document.querySelector('.membership-title');

    if (!membershipTitle) {
        return;
    }

    if (memberPrice > nonMemberPrice) {
        // Membership costs more - show value message
        membershipTitle.textContent = 'Join Membership and Save!';
    } else {
        // Membership saves money - show savings amount
        const savings = Math.round(nonMemberPrice - memberPrice);
        membershipTitle.textContent = `Join Membership and Save $${savings}`;
    }
}

// Update membership pricing based on selected package
function updateMembershipPricing() {
    const packageData = loadFromSession('selectedPackage', 'packageTimestamp', true);

    if (!packageData || !packageData.type) {
        console.warn('No package selected, cannot update pricing');
        return;
    }

    const packageType = packageData.type;

    // Get package pricing using the existing function
    let nonMemberPrice = 0;
    let memberPrice = 0;

    // Get pricing for both membership types
    nonMemberPrice = getPackagePriceByMembership(packageType, 'Non-Member');
    memberPrice = getPackagePriceByMembership(packageType, 'OneLife Annual Membership');

    if (nonMemberPrice > 0 && memberPrice > 0) {
        const regularPricingDiv = document.querySelector('.membership-pricing');
        const higherPricingDiv = document.querySelector('.membership-pricing-if-higher');
        const membershipCardSubtitle = document.querySelector('.membership-card-subtitle');

        // Check if membership costs more than non-member (like Signature package)
        if (memberPrice > nonMemberPrice) {
            // Show alternative layout for higher membership price
            if (membershipCardSubtitle) membershipCardSubtitle.style.display = 'none';
            if (regularPricingDiv) regularPricingDiv.style.display = 'none';
            if (higherPricingDiv) {
                higherPricingDiv.style.display = 'block';

                // Update the membership price
                const membershipPriceElement = higherPricingDiv.querySelector('.membership-price');
                if (membershipPriceElement) {
                    membershipPriceElement.textContent = `$${Math.round(memberPrice)}`;
                }

                // Calculate and show the additional cost
                const additionalCost = memberPrice - nonMemberPrice;
                const additionalPriceElement = higherPricingDiv.querySelector('.additional-price');
                if (additionalPriceElement) {
                    additionalPriceElement.textContent = `Only $${Math.round(additionalCost)} more`;
                }
            }

            // Update membership title for higher pricing case
            updateMembershipTitle(nonMemberPrice, memberPrice);
        } else {
            // Show regular layout for membership savings
            if (higherPricingDiv) higherPricingDiv.style.display = 'none';
            if (membershipCardSubtitle) membershipCardSubtitle.style.display = 'block';
            if (regularPricingDiv) {
                regularPricingDiv.style.display = 'flex';

                // Update the pricing display
                const originalPriceElement = regularPricingDiv.querySelector('.original-price');
                const membershipPriceElement = regularPricingDiv.querySelector('.membership-price');

                if (originalPriceElement) {
                    originalPriceElement.textContent = `$${Math.round(nonMemberPrice)}`;
                }

                if (membershipPriceElement) {
                    membershipPriceElement.textContent = `$${Math.round(memberPrice)}`;
                }
            }
        }

        // Update membership title based on pricing
        updateMembershipTitle(nonMemberPrice, memberPrice);
    } else {
        console.warn('Could not get pricing for package:', packageType);
    }
}

// Setup membership button functionality
function setupMembershipButtons() {
    const joinMembershipBtn = document.querySelector('.join-membership-btn');
    const continueWithoutBtn = document.querySelector('.continue-without-btn');

    if (joinMembershipBtn) {
        joinMembershipBtn.addEventListener('click', function (e) {
            e.preventDefault();
            addToCartWithMembership(true);
        });
    }

    if (continueWithoutBtn) {
        continueWithoutBtn.addEventListener('click', function (e) {
            e.preventDefault();
            addToCartWithMembership(false);
        });
    }
}

// Add selected package and membership to cart (unified function for both restricted and non-restricted states)
function addToCartWithMembership(withMembership) {
    // Get saved appointment data from session storage
    const appointmentData = loadSelectedAppointmentFromSession();

    // Get saved package data from session storage
    const packageData = loadFromSession('selectedPackage', 'packageTimestamp', true);

    // Get saved gender from session storage
    const gender = loadFromSession('selectedGender', 'genderTimestamp') || 'female';

    // Get saved date of birth from session storage
    const dateOfBirth = loadDateOfBirthFromSession();

    if (!appointmentData) {
        alert('Please select an appointment location and time before proceeding.');
        return;
    }

    if (!packageData) {
        alert('Please select a package before proceeding.');
        return;
    }

    // Get the correct variant ID based on membership choice and package type
    const variantId = getVariantIdForSelection(packageData.type, withMembership);

    if (!variantId) {
        alert('Unable to determine product variant. Please try again.');
        return;
    }

    // Use the already-formatted date from appointment data
    const formattedDate = appointmentData.date;
    const fullAddress = `${appointmentData.address}`;

    // Calculate the actual price for this selection
    const membershipType = withMembership ? 'OneLife Annual Membership' : 'Non-Member';
    const packagePrice = getPackagePriceByMembership(packageData.type, membershipType);

    // Format pricing based on membership status
    const packageName = `${packageData.type.charAt(0).toUpperCase() + packageData.type.slice(1)}`;
    let properties = {};

    if (withMembership) {
        // Member format: Show membership with package and total price
        // Keep this commented out // properties[`OneLife Annual Membership / ${packageName}`] = `$${Math.round(packagePrice)}`;
        properties['Physician Review Fee'] = 'Waived';
        properties['Membership Status'] = 'OneLife Annual Membership';
        properties['Renews at'] = '$197/per year';
    } else {
        // Non-member format: Show package with base price, then physician fee separately
        const basePrice = Math.max(0, packagePrice - 19); // Subtract physician fee from total
        properties[`${packageName} Package`] = `$${basePrice}`;
        properties['Physician Review Fee'] = '$19';
    }

    // Include any global metafield properties
    const metafieldProperties = getMetafieldLineItemProperties(variantId);

    // Add common appointment details
    properties.Date = formattedDate;
    properties.Time = appointmentData.time;
    properties.Location = appointmentData.location;
    properties.Address = fullAddress;
    properties._appointment_id = appointmentData._appointment_id || '';
    properties.Gender = gender[0].toUpperCase() + gender.slice(1);
    properties = { ...properties, ...metafieldProperties };
    if (typeof dateOfBirth === 'string' && dateOfBirth !== '' && dateOfBirth !== 'Invalid Date') {
        properties['Date of Birth'] = dateOfBirth;
    }

    // Prepare cart data with new format
    const cartData = {
        items: [
            {
                id: variantId,
                quantity: 1,
                properties: properties,
            },
        ],
    };

    // Clear cart first to ensure only this product is added
    fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
    })
        .then((response) => response.json())
        .then((clearData) => {
            // Add to cart using same method as llsa-search.js
            return fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(cartData),
            });
        })
        .then((response) => response.json())
        .then((data) => {
            if (data.status === 422) {
                alert('Error adding item to cart. Please try again.');
                console.error('Cart error:', data);
            } else {
                window.location.href = '/checkout';
            }
        })
        .catch((error) => {
            console.error('Error with cart operations:', error);
            alert('Error processing your order. Please try again.');
        });
}

// Get the correct variant ID based on package type and membership choice
function getVariantIdForSelection(packageType, withMembership) {
    // Get the packages product data
    const packagesProductData = getPackagesProductData();

    if (!packagesProductData || !packagesProductData.variants) {
        console.error('Package product data not available');
        return null;
    }

    // Find the correct variant based on membership choice and package type
    const membershipOption = withMembership ? 'OneLife Annual Membership' : 'Non-Member';

    // Map package data attribute to variant option2 value
    let enhancementOption;
    const normalizedPackageType = packageType.toLowerCase();

    switch (normalizedPackageType) {
        case 'signature':
            enhancementOption = 'None';
            break;
        case 'silver':
            enhancementOption = 'Silver';
            break;
        case 'gold':
            enhancementOption = 'Gold';
            break;
        case 'platinum':
            enhancementOption = 'Platinum';
            break;
        default:
            console.warn('Unknown package type:', packageType, 'using fallback capitalization');
            enhancementOption = packageType.charAt(0).toUpperCase() + packageType.slice(1);
    }

    const variant = packagesProductData.variants.find(
        (v) => v.option1 === membershipOption && v.option2 === enhancementOption,
    );

    if (variant) {
        return variant.id;
    }

    console.error('Could not find variant for:', {
        packageType,
        membershipOption,
        enhancementOption,
        availableVariants: packagesProductData.variants.map((v) => ({
            id: v.id,
            option1: v.option1,
            option2: v.option2,
            title: v.title,
        })),
    });
    return null;
}

// Format date helper (same as llsa-search.js)
function formatDate(dateStr) {
    if (!dateStr) return '';

    let date;

    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
        const [year, month, day] = dateStr.split('-').map(Number);
        date = new Date(year, month - 1, day);
    } else {
        date = new Date(dateStr);
    }

    const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

    const weekday = capitalize(date.toLocaleString('en', { weekday: 'long' }));
    const monthName = capitalize(date.toLocaleString('en', { month: 'long' }));
    const dayNum = date.getDate();
    return `${weekday} ${monthName} ${dayNum}`;
}

// Setup close button for appointment and package summary
function setupAppointmentPackageSummaryCloseButton() {
    const closeButton = document.getElementById('appointment-package-summary-close');

    if (closeButton) {
        closeButton.addEventListener('click', function (e) {
            e.preventDefault();
            hideAppointmentAndPackageSummary();
        });

        // Add keyboard support
        closeButton.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                hideAppointmentAndPackageSummary();
            }
        });
    }
}

// Hide appointment and package summary
function hideAppointmentAndPackageSummary() {
    const summaryContainer = document.getElementById('selected-appointment-and-package-summary');

    if (summaryContainer) {
        summaryContainer.style.display = 'none';
    }
}

// Setup modify button for appointment and package summary
function setupAppointmentPackageModifyButton() {
    const modifyBtn = document.getElementById('appointment-package-modify-btn');

    if (modifyBtn) {
        // Remove existing event listeners to prevent duplicates
        modifyBtn.replaceWith(modifyBtn.cloneNode(true));
        const newModifyBtn = document.getElementById('appointment-package-modify-btn');

        newModifyBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            // Navigate back to package selection
            if (typeof showPackageSelection === 'function') {
                showPackageSelection();
            } else {
                console.warn('showPackageSelection function not available');
            }
        });

        // Add keyboard support
        newModifyBtn.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                if (typeof showPackageSelection === 'function') {
                    showPackageSelection();
                }
            }
        });
    }
}

// Setup function to get product and variant metafields for line item properties
function getMetafieldLineItemProperties(variantId) {
    const container = document.getElementById('llsa-global-metafields');
    if (!container) return {};

    try {
        const snapshot = JSON.parse(container.textContent || '{}');
        if (!snapshot) return {};

        const properties = {};
        const normalizeKey = (key) =>
            String(key || '')
                .replace(/\s+/g, '_')
                .replace(/[^\w.-]/g, '_')
                .toLowerCase();

        // Loop through each product in the snapshot
        for (const productId in snapshot) {
            const product = snapshot[productId];
            // Product-level metafields
            const productMetafields = product.metafields || {};
            Object.entries(productMetafields).forEach(([key, value]) => {
                // @ts-ignore
                if (value) properties[`_product_${normalizeKey(key)}`] = String(value);
            });

            // Variant-level metafields
            const variantMetafields = product.variants?.[String(variantId)]?.metafields || {};
            Object.entries(variantMetafields).forEach(([key, value]) => {
                // @ts-ignore
                if (value) properties[`_variant_${normalizeKey(key)}`] = String(value);
            });
        }

        return properties;
    } catch (error) {
        console.error('❌ Could not parse global metafields JSON', error);
        return {};
    }
}

// Initialize membership step functionality
function initializeMembershipStep() {
    // Setup close button functionality
    setupAppointmentPackageSummaryCloseButton();

    // Setup modify button functionality
    setupAppointmentPackageModifyButton();

    // Setup membership buttons functionality
    setupMembershipButtons();
}

// Expose functions globally
window.showMembershipStep = showMembershipStep;
window.initializeMembershipStep = initializeMembershipStep;

// Auto-initialize when script loads
document.addEventListener('DOMContentLoaded', function () {
    initializeMembershipStep();
});
